import { configureStore } from "@reduxjs/toolkit";
import authenticationReducer from "../features/auth/authSlice";
import PatientelleReducer from "../features/patientelle/patientelleSlice";
import countersReducer from "../features/counter/counterSlice";
import priseEnChargeReducer from "../features/PriseEnCharge/PriseEnChargeSlice";

export const store = configureStore({
  reducer: {
    Counters: countersReducer,
    Authentication: authenticationReducer,
    PatientelleGrid: PatientelleReducer,
    PriseEnCharge: priseEnChargeReducer,
  },
});
